module.exports = __webpack_public_path__ + "img/green-carpet-grass-02.cd170ff9.png";